<template>
  <div>
    <div class="ticket-buy-wrap" id="voucher">

      <my-pooq-empty-list v-if="isEmptyVoucher" info-text="구매 가능한 상품이 없어요."/>

      <template v-if="voucherList.length > 0">
        <!--상단 이용권 리스트 (단건구매, 이용중)-->
        <div class="ticket-wrap">
          <div v-for="(voucher, index) in getOneUseList" :key="index">
            <h3 class="movie-voucher-title">{{voucher.passgroup_name}}</h3>
            <movie-voucher-top v-for="(productgroups, index2) in voucher.productgroups" :key="index2"
                               :productgroups="productgroups" :passgroupType="voucher.passgroup_type"
                               :content-id="contentId"/>
          </div>
        </div>
        <!--상단 이용권 리스트 (단건구매, 이용중)-->

        <!--상단 이용권 리스트 (추천이용권, 패키지)-->
        <div v-for="(voucherPackage, index) in getVoucherPackageList" :key="index" class="ticket-wrap">
          <h3 class="movie-voucher-title">{{voucherPackage.passgroup_name}}</h3>
          <movie-voucher-top v-for="(productgroups, index) in voucherPackage.productgroups" :key="index"
                             :productgroups="productgroups" :passgroupType="voucherPackage.passgroup_type"
                             :content-id="contentId"/>
        </div>
        <!--상단 이용권 리스트 (추천이용권, 패키지)-->
      </template>
      <!-- // 상단 이용권 영역 -->

      <!-- 영화 월정액 이용권 영역 -->
      <template v-if="isOpenVoucher">
        <movie-product-category v-for="(voucher, index) in getBottomVoucherList"
                                :key="index"
                                :category="voucher"
                                :voucherData="[]"
                                :categoryNum="index"
                                :content-id="contentId"/>
      </template>

      <div v-if="getBottomVoucherList.length" class="more-ticket">
        <button @click="isOpenVoucher = !isOpenVoucher">
          <img src="/img/common/ico-tickets.png" class="ico-tickets" alt=""/>
          <template v-if="isOpenVoucher">영화 월정액 이용권 닫기</template>
          <template v-else>영화 월정액 이용권 더보기</template>
          <img v-if="!isOpenVoucher" src="/img/common/arrow-open-purple.png" class="more-ticket-arrow"  alt=""/>
          <img v-else src="/img/common/arrow-close-purple.png" class="more-ticket-arrow" alt=""/>
        </button>
      </div>
    </div>
    <portal to="info-popup">
      <movie-package-popup v-if="dataPackageList.length" :data-list="dataPackageList" :title="packageTitle"/>
    </portal>
  </div>
</template>

<script>
import { BottomTabService } from '@/common/api/api.service'
import MyPooqEmptyList from '@/components/lnb/mypooq/MyPooqEmptyList'
import MovieProductCategory from '@/components/play/bottom-tab/MovieProductCategory'
import MovieVoucherTop from '@/components/play/bottom-tab/MovieVoucherTop'
import MoviePackagePopup from '@/components/play/bottom-tab/MoviePackagePopup'
import { EventBus } from '@/components/lnb/voucher/VoucherEventBus'
import { disableBodyScroll, enableBodyScroll } from '@/common/util/ui.utils'
import { get, set, each } from 'lodash'

export default {
  name: 'VoucherContentList',
  components: {
    MyPooqEmptyList,
    MovieProductCategory,
    MovieVoucherTop,
    MoviePackagePopup
  },
  props: {
    contentInfo: {
      type: Object
    },
    section: {
      type: String
    }
  },
  data () {
    return {
      voucherList: [],
      isOpenVoucher: false,
      contentId: '',
      packageTitle: '',
      dataPackageList: [],
      isEmptyVoucher: false
    }
  },
  methods: {
    setContentId () {
      if (this.section === 'movie') {
        this.contentId = this.contentInfo.movieid
      }
    },
    getParameters () {
      if (this.section === 'movie') {
        let param = {
          cpid: this.contentInfo.cpid,
          channelid: 'none',
          programid: this.contentInfo.movieid,
          contentid: this.contentInfo.movieid,
          contenttype: 'movie',
          vouchertype: 'use'
        }
        const movieMarks = get(this.contentInfo, ['moviemarks'], [])
        if (movieMarks.indexOf('playy') > -1) {
          param.isplayy = 'y'
          param.recommendvoucher = 'none'
        }
        return param
      }
    },
    setData () {
      BottomTabService.purchaseProducts(this.getParameters()).then(({ data }) => {
        let emptyVoucherList = []
        let tempVoucherList = []
        each(data, (voucher, voucherIndex) => {
          if (voucher.productgroups.length > 0) {
            each(voucher.productgroups, (productGroup) => {
              each(productGroup.products, (product) => {
                if (product.concurrency_count === '0') {
                  emptyVoucherList.push(voucherIndex)
                }
                // each(product.concurrency, (concurency) => {
                //   if (concurency.concurrency_count === '0') {
                //     emptyVoucherList.push(voucherIndex)
                //   }
                // })
              })
            })
          }
        })
        emptyVoucherList.forEach((voucherIndex) => {
          tempVoucherList = set(data, [voucherIndex, 'productgroups'], [])
        })
        this.voucherList = tempVoucherList.length > 0 ? tempVoucherList : data
        const emptyList = this.voucherList.filter((voucherInfo, index) => {
          return Number(get(voucherInfo, 'productgroups_count', '0')) === 0
        })
        if (emptyList.length === this.voucherList.length) {
          this.isEmptyVoucher = true
        }
        console.log(this.voucherList)
      })
    }
  },
  computed: {
    getOneUseList () {
      return this.voucherList.filter((data) => {
        if ((data.passgroup_type === 'one' || data.passgroup_type.indexOf('use') > -1) &&
          data.productgroups.length) {
          return data
        }
        return false
      })
    },
    // 상단 이용권 리스트 (추천이용권, 패키지)
    getVoucherPackageList () {
      return this.voucherList.filter((data) => {
        if ((data.passgroup_type === 'voucher' || data.passgroup_type === 'package') &&
          data.productgroups.length) {
          return data
        }
        return false
      })
    },
    // 하단 이용권 리스트
    getBottomVoucherList () {
      return this.voucherList.filter((data) => {
        if ((data.passgroup_type === 'pooq' || data.passgroup_type.indexOf('partner') >= 0) &&
          data.productgroups.length) {
          return data
        }
        return false
      })
    }
  },
  created () {
    this.setContentId()
    this.setData()
    EventBus.$on('setPackagePopupOpen', (productid, title) => {
      this.packageTitle = title // 패키지 더보기 팝업에서 사용되는 전체 title
      BottomTabService.purchaseProductContents(
        { productid: productid,
          contenttype: 'movie',
          offset: 0,
          limit: 100 })
        .then(({ data }) => {
          data.forEach((item) => {
            if (item.type === 'movielist') {
              this.dataPackageList = item.list
            }
          })
        })
      disableBodyScroll() // 바닥 화면 스크롤 방지
    })
    EventBus.$on('setPackagePopupClose', () => {
      this.dataPackageList = []
      enableBodyScroll()
    })
  }
}
</script>

<style scoped>
.ticket-buy-wrap {
  background-color: #101010;
  padding: 10px;
}
.ticket-wrap {
  margin-bottom: 10px !important;
}
.more-ticket {
  text-align: center;
  padding: 20px 0;
}
.more-ticket button {
  font-size: 14px;
  color: #23212a;
}
.more-ticket img {
  display: inline-block;
  margin-top: -3px;
}
.ico-tickets {
  width: 20px;
}
.more-ticket img {
  display: inline-block;
  margin-top: -3px;
}

.more-ticket-arrow {
  width: 12px;
}
</style>
